// The Calvary wordmark lockup — "CALVARY" in the display serif with a
// letter-spaced "BUILDING SERVICES INC" sublabel. `nav` centers the sublabel
// between two gold rules (header); `footer` stacks it left-aligned.
export default function Wordmark({
  variant = "nav",
}: {
  variant?: "nav" | "footer";
}) {
  const isNav = variant === "nav";
  return (
    <div className={isNav ? "" : "leading-none"}>
      <div
        className="font-serif font-semibold leading-none text-cream"
        style={{
          fontSize: isNav ? "28px" : "26px",
          letterSpacing: "0.24em",
        }}
      >
        CALVARY
      </div>
      {isNav ? (
        <div className="mt-[5px] flex items-center gap-2">
          <span className="h-px w-4 bg-gold" />
          <span
            className="font-medium text-gold"
            style={{ fontSize: "8.5px", letterSpacing: "0.4em" }}
          >
            BUILDING SERVICES INC
          </span>
          <span className="h-px w-4 bg-gold" />
        </div>
      ) : (
        <div
          className="mt-[5px] font-medium text-gold"
          style={{ fontSize: "9px", letterSpacing: "0.4em" }}
        >
          BUILDING SERVICES INC
        </div>
      )}
    </div>
  );
}
